/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum DiagnosisEditorAliases {
  ACTION_DELETE_DIAGNOSIS = 'action-delete-diagnosis',
  ACTION_NEW_DIAGNOSIS = 'action-new-diagnosis',
  AUTOC_CLASSIFICATION = 'autoc-classification',
  AUTOC_SIDE = 'autoc-side',
  AUTOC_TYPE_DIAGNOSIS = 'autoc-type-diagnosis',
  AUTOC_TYPE_DISEASE = 'autoc-type-disease',
  BUTTON_RELEASE = 'button-release',
  CONTEXTUAL_BAR_DIAGNOSIS = 'contextual-bar-diagnosis',
  FETCH_CLASSIFICATION = 'fetch-classification',
  FETCH_DIAGNOSIS = 'fetch-diagnosis',
  FETCH_SIDE = 'fetch-side',
  FETCH_TYPE_DIAGNOSIS = 'fetch-type-diagnosis',
  FETCH_TYPE_DISEASE = 'fetch-type-disease',
  FIELD_CLASSIFICATION = 'field-classification',
  FIELD_DESCRIPTION = 'field-description',
  FIELD_DIAGNOSIS = 'field-diagnosis',
  FIELD_EVOLUTION_DATE = 'field-evolution-date',
  FIELD_SIDE = 'field-side',
  FIELD_TYPE_DIAGNOSIS = 'field-type-diagnosis',
  FIELD_TYPE_DISEASE = 'field-type-disease',
  FORM_DIAGNOSIS = 'form-diagnosis',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  INPUT_0 = 'input-0',
  INPUT_DATETIME = 'input-datetime',
  LAYOUT_DIAGNOSIS_EDITOR = 'layout-diagnosis-editor',
  LAYOUT_DIAGNOSIS_EDITOR_CONTENT = 'layout-diagnosis-editor-content',
  LOADER_DIAGNOSIS1 = 'loader-diagnosis1',
  LOCATOR_0 = 'locator-0',
  LOCATOR_FIELD_0 = 'locator-field-0',
  MAPPER_CLASSIFICATION = 'mapper-classification',
  MAPPER_SIDE = 'mapper-side',
  MAPPER_TYPE_DIAGNOSIS = 'mapper-type-diagnosis',
  MAPPER_TYPE_DISEASE = 'mapper-type-disease',
  PANEL_BUTTON = 'panel-button',
  PANEL_FORM = 'panel-form',
  PANEL_LOAD_RELEASE = 'panel-load-release',
  PANEL_MENU_FRAGMENT = 'panel-menu-fragment',
  PANEL_RELEASE = 'panel-release',
  TEXT_AREA_DESCRIPTION = 'text-area-description',
  TEXT_CLASSIFICATION = 'text-classification',
  TEXT_SIDE = 'text-side',
  TEXT_TYPE_DIAGNOSIS = 'text-type-diagnosis',
  TEXT_TYPE_DISEASE = 'text-type-disease',
  TOAST_WARNING = 'toast-warning',
}
export { DiagnosisEditorAliases };
